import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function createNewRole(request) {
  const { role, application } = request
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  headers['App-Name'] = application
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.post('/role', { roles: [role] })
}

export async function updateARole(request) {
  const { role, application } = request
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  headers['App-Name'] = application
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.put('/role', role)
}

export async function assignPermissionsToRole(request) {
  const { roleName, application, permissions } = request
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  headers['App-Name'] = application
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.put('/permissions-to-role', {
    roleName,
    permissions,
  })
}

export async function deleteARole(request) {
  const { role, application } = request
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  headers['App-Name'] = application
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.delete('/role', {
    data: role,
  })
}
